<div class="checkbox-container {{size}}" [ngClass]="{'margin-top': !!label}">
    <span class="lg checkbox text-primary"
        (click)="internalClick()">
        <fa-icon *ngIf="!value" [icon]="['far', 'square']" [size]="size" [ngClass]="{'text-muted': disabled}"></fa-icon>
        <fa-icon *ngIf="value" [icon]="['far', 'check-square']" [size]="size" [ngClass]="{'text-muted': disabled}"></fa-icon>
    </span>
    <div *ngIf="label" class="checkbox-label" (click)="internalClick()">{{label | translate}}</div>
</div>
